import React from 'react';
import { motion } from 'framer-motion';
import { EggIcon, DumbbellIcon, CalendarIcon } from 'lucide-react';
const pillars = [{
  icon: EggIcon,
  title: '30g Proteína',
  subtitle: 'en el Desayuno',
  description: 'Silencia la hormona del hambre y estabiliza tu azúcar en sangre para todo el día.'
}, {
  icon: DumbbellIcon,
  title: '30 Minutos',
  subtitle: 'de Fuerza',
  description: 'Tensión mecánica que crea músculo que quema calorías incluso cuando duermes.'
}, {
  icon: CalendarIcon,
  title: '3 Veces',
  subtitle: 'por Semana',
  description: 'La recuperación es tan importante como el esfuerzo. Tu cuerpo necesita descanso.'
}];
export function ProtocolSection() {
  return <section className="w-full bg-cream py-16 md:py-24 px-4" data-id="element-101">
      <div className="max-w-7xl mx-auto" data-id="element-102">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-4xl md:text-5xl font-bold text-terracotta text-center mb-4" data-id="element-103">
          El Método 30-30-3
        </motion.h2>
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl text-sage text-center mb-16" data-id="element-104">
          Tu Nuevo Protocolo
        </motion.p>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-105">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-sage/10 p-8 rounded-lg text-center hover:shadow-xl transition-shadow" data-id="element-106">
              <div className="flex justify-center mb-6" data-id="element-107">
                <div className="bg-terracotta/10 p-4 rounded-full" data-id="element-108">
                  <pillar.icon className="w-12 h-12 text-terracotta" data-id="element-109" />
                </div>
              </div>
              <h3 className="font-serif text-3xl font-bold text-terracotta mb-2" data-id="element-110">
                {pillar.title}
              </h3>
              <p className="font-serif text-xl text-sage mb-4" data-id="element-111">
                {pillar.subtitle}
              </p>
              <p className="text-brown leading-relaxed" data-id="element-112">{pillar.description}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gold/20 border-l-4 border-gold p-6 rounded-lg" data-id="element-113">
          <p className="text-lg md:text-xl text-brown italic text-center" data-id="element-114">
            "Tu metabolismo es una fogata. Deja de lanzarle papel y empieza a
            ponerle troncos de roble."
          </p>
        </motion.div>
      </div>
    </section>;
}